import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { isArray } from 'lodash';
import qs from 'qs';
import { api } from '.';
import { handleApiRequestSuccessData, handleRequestError } from '../utils/request';
/**
 * Query exchange rate
 */

export var apiQueryExchangeRate = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return api.get("/currency/exchange_rage/all");

          case 3:
            res = _context.sent;
            return _context.abrupt("return", [res.data]);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", [null, _context.t0]);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function apiQueryExchangeRate() {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Query exchange rate
 */

export var apiGeneralUploadImage = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
    var formData, params, res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            formData = new FormData();
            formData.append('file', payload === null || payload === void 0 ? void 0 : payload.file);
            params = {
              is_logo: payload === null || payload === void 0 ? void 0 : payload.is_logo,
              img_type: payload === null || payload === void 0 ? void 0 : payload.img_type
            };
            _context2.next = 6;
            return api.post("/general/upload_image?".concat(qs.stringify(params)), formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });

          case 6:
            res = _context2.sent;
            return _context2.abrupt("return", [res.data]);

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", handleRequestError(payload));

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 10]]);
  }));

  return function apiGeneralUploadImage(_x) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * Query address by postcode
 */

export var apiQueryUKAddressByPostcode = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
    var _res$data, res;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return api.get("/companies_house/address?".concat(qs.stringify(payload)));

          case 3:
            res = _context3.sent;

            if (isArray(res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data)) {
              res.data.data = res.data.data.map(function (item) {
                item.value = item.id;
                item.label = item.suggestion;
                return item;
              });
            }

            return _context3.abrupt("return", [res.data]);

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", handleRequestError(_context3.t0));

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 8]]);
  }));

  return function apiQueryUKAddressByPostcode(_x2) {
    return _ref3.apply(this, arguments);
  };
}();
export var apiGetUKAddressDetailInfoByPostcode = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return api.get("/companies_house/address/detail?".concat(qs.stringify(payload)));

          case 3:
            res = _context4.sent;
            return _context4.abrupt("return", [res.data]);

          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", handleRequestError(_context4.t0));

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 7]]);
  }));

  return function apiGetUKAddressDetailInfoByPostcode(_x3) {
    return _ref4.apply(this, arguments);
  };
}();
export var apiGetUserRedirectInformation = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return api.post("/users/cms/middle-page/redirect", payload);

          case 3:
            res = _context5.sent;
            handleApiRequestSuccessData(res);
            return _context5.abrupt("return", [res.data]);

          case 8:
            _context5.prev = 8;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", handleRequestError(_context5.t0));

          case 11:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 8]]);
  }));

  return function apiGetUserRedirectInformation(_x4) {
    return _ref5.apply(this, arguments);
  };
}();